import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import Auth, {Permission} from '../../utils/auth';
import PaymentHistoryWrapper from './components/PaymentHistoryWrapper';

class PaymentHistory extends React.Component<RouteComponentProps> {
  grantPermission(regionId: string, type: Permission): boolean {
    const roles: Array<string> = Auth.getRoles();
    const regionRoles = roles.filter(role => role.includes('regionRole'));
    const requiredRoles = regionRoles.filter(role => role.includes(type)).map(role => role.split(':')[1]);

    if (roles.some(role => role === 'admin')) {
      return true;
    }

    return requiredRoles.some(allowedRegion => allowedRegion === regionId);
  }

  getPath() {
    return window.location.pathname.substr(1).split('/');
  }

  getScene() {
    const path = this.getPath();

    if (path[1] && !this.grantPermission(path[1], Permission.Orders)) {
      this.props.history.push('/error/authorization');
      return <div />;
    }
    return <PaymentHistoryWrapper regionId={path[1]} />;
  }

  render() {
    return this.getScene();
  }
}

export default withRouter(PaymentHistory);



// WEBPACK FOOTER //
// ./src/pages/PaymentHistoryPage/PaymentHistoryPage.tsx